import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  PredictOptions,
  PredictResponse,
  predict as universalPredict,
} from './atlas-v2-prediction-autocomplete.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/atlas' };

export function predict(httpClient: HttpClient): PredictSignature {
  return (input: string, options?: PredictOptions) =>
    universalPredict(
      input,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface PredictSignature {
  /**
   * A Predict end-point take an input and returns an list of Prediction object.
   * @param - The text the predictions will be based on.
   */
  (input: string, options?: PredictOptions): Promise<
    NonNullablePaths<
      PredictResponse,
      | `predictions`
      | `predictions.${number}.description`
      | `predictions.${number}.searchId`
      | `predictions.${number}.textStructure.mainText`
      | `predictions.${number}.textStructure.secondaryText`,
      5
    >
  >;
}

export {
  AddressLocation,
  FilterBy,
  FilterType,
  ListPredictionsRequest,
  ListPredictionsResponse,
  MatchedSubstrings,
  PredictOptions,
  PredictRequest,
  PredictResponse,
  Prediction,
  TextStructure,
} from './atlas-v2-prediction-autocomplete.universal.js';
